<div>
  <div class="d-flex c-fixed-mb">
    <div><i aria-hidden="true" class="p-1 me-1 fas fa-exclamation-triangle fa-2x"></i></div>
    <div [innerHTML]="confirmMessage"></div>
  </div>
  <div class="btn-dialog">
    <button type="button" class="btn btn-active" (click)="onConfirmSubmit('Approve')" value="Approve">{{ dtnDisplayName }}</button>
    <button type="button" class="btn btn-active" (click)="onConfirmSubmit('Cancel')" value="Cancel">Cancel</button>
  </div>
 </div>

